
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import config from "@/config/config";
import gateway from "@/lib/request/gateway";
import PostPolicy from "@/lib/model/gateway/post-policy";
import _ from "lodash-es";
import Auth from "@/lib/common/auth";
import UploadedFile from "@/lib/model/gateway/uploaded-file";

@Component({})
export default class UploadVideo extends Vue {
  @Prop({ default: "examLogoUrl", type: String }) private imgType!: string;
  @Prop({ default: "", type: String }) img!: string;
  // @Prop({ default: "", type: String }) videoId!: string;
  name = "paper-list";
  loading = false;
  params = {};
  headers = {};
  imageUrl = ""; //视频播放地址
  postPolicy: PostPolicy = new PostPolicy();
  uploadFile: UploadedFile = new UploadedFile();

  uploader: any; //阿里云
  timeout = "";
  partSize = "";
  parallel = "";
  retryCount = "";
  retryDuration = "";
  region = "cn-shanghai";
  userId = "1303984639806000";
  file = null;
  authProgress = 0;
  uploadDisabled = true;
  resumeDisabled = true;
  pauseDisabled = true;
  statusText = "";

  uploading = false; //上传中
  uploaded = 0;
  uploadTotal = 0;

  downloading = false; //下载中
  downloaded = 0;
  downloadTotal = 0;

  get uploadUrl() {
    return _.trim(config.accountUrl) + "/api/common/uploadOss";
  }
  get token() {
    return Auth.token;
  }
  get percent() {
    return Math.floor((this.uploaded / this.uploadTotal) * 100) || 0;
  }
  get downloadPercent() {
    return Math.floor((this.downloaded / this.downloadTotal) * 100) || 0;
  }

  @Watch("img", { immediate: true })
  onImgChange(val: string) {
    this.imageUrl = val;
  }
  mounted() {
    // this.imageUrl = this.img;
  }
  //上传
  up() {
    (this.$refs.up as any)?.click();
  }

  // afterUpload(e: any) {
  //   this.loading = false;
  //   if (e.code === 0) {
  //     this.imageUrl = e.data.url;
  //   }
  // }

  fileChange(e: any) {
    const file = e?.target?.files?.[0] as File;
    if (!file) return;
    const isMP4 = file.type.includes("mp4") || file.type.includes("MP4");
    const isLt2M = file.size / 1024 / 1024 < 500;
    if (!isMP4) {
      this.$message.warning("请上传MP4格式视频");
      return false;
    }
    if (!isLt2M) {
      this.$message.warning("视频大小不能超过500M");
      return false;
    }
    this.uploaded = 0;
    this.uploadTotal = 0;
    this.uploading = true;
    // 上传到oss
    gateway.anonymousGetPostPolicy(file.name).then((postRes: any) => {
      if (postRes) {
        const tempUrl = postRes.cdn + "/" + encodeURIComponent(postRes.dir);
        const config: any = {
          onUploadProgress: (progressEvent: any) => {
            //progressEvent.loaded:已上传文件大小
            //progressEvent.total:被上传文件的总大小
            this.uploaded = progressEvent.loaded;
            this.uploadTotal = progressEvent.total;
          }
        };
        gateway
          .upload(postRes, file, config)
          .then(() => {
            this.$emit("setVideoUrl", tempUrl);
            //获取宽高比例
            const video = document.createElement("video");
            video.onloadedmetadata = () => {
              const WH = video.videoWidth / video.videoHeight;
              this.$emit("setVideoWH", WH);
            };
            video.src = URL.createObjectURL(file);

            this.uploading = false;
          })
          .finally(() => {
            this.uploading = false;
          });
      }
    });
  }
  //走VOD转码  业务迭代 已弃用， 代码留着备用
  fileChangeOld(e: any) {
    this.file = e.target.files[0];
    if (!this.file) {
      this.$message.warning("请先选择需要上传的文件!");
      return;
    }
    if ((this.file as any)?.type.substring(0, 5) !== "video") {
      this.$message.warning("请选常用的视频格式!");
      return;
    }

    const url = URL.createObjectURL(this.file);
    console.log(url);
    // const aaaa = document.getElementById("see");
    // (document.getElementById("see") as any).src = url;
    this.$emit("videoUrl", url);
    const userData = '{"Vod":{}}';
    if (this.uploader) {
      this.uploader.stopUpload();
    }
    this.uploader = this.createUploader();
    this.uploader.addFile(this.file, null, null, null, userData);
    if (this.uploader !== null) {
      this.uploader.startUpload();
    }
  }
  //vod已弃用 备用
  createUploader() {
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const uploader: any = new AliyunUpload.Vod({
      timeout: self.timeout || 60000,
      partSize: self.partSize || 1048576,
      parallel: self.parallel || 5,
      retryCount: self.retryCount || 3,
      retryDuration: self.retryDuration || 2,
      region: self.region,
      userId: self.userId,
      // 添加文件成功
      addFileSuccess: function(uploadInfo: any) {
        self.uploadDisabled = false;
        self.resumeDisabled = false;
        self.statusText = "添加文件成功, 等待上传...";
        //清除可能存在的旧视频
        self.delImg();
        self.$emit("clearVideoUrl");
        console.log("addFileSuccess: " + uploadInfo.file.name);
      },
      // 开始上传
      onUploadstarted: function(uploadInfo: any) {
        // 如果是 UploadAuth 上传方式, 需要调用 uploader.setUploadAuthAndAddress 方法
        // 如果是 UploadAuth 上传方式, 需要根据 uploadInfo.videoId是否有值，调用点播的不同接口获取uploadauth和uploadAddress
        // 如果 uploadInfo.videoId 有值，调用刷新视频上传凭证接口，否则调用创建视频上传凭证接口
        // 注意: 这里是测试 demo 所以直接调用了获取 UploadAuth 的测试接口, 用户在使用时需要判断 uploadInfo.videoId 存在与否从而调用 openApi
        // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)
        // 如果 uploadInfo.videoId 不存在,调用 获取视频上传地址和凭证接口(https://help.aliyun.com/document_detail/55407.html)
        if (!uploadInfo.videoId) {
          //获取上传凭证
          gateway
            .uploadVideoPre({
              title: uploadInfo.file.name,
              filename: uploadInfo.file.name
            })
            .then((data: any) => {
              const uploadAuth = data.uploadAuth;
              const uploadAddress = data.uploadAddress;
              const videoId = data.videoId;
              self.$emit("setVideoId", videoId);
              self.uploading = true;
              uploader.setUploadAuthAndAddress(
                uploadInfo,
                uploadAuth,
                uploadAddress,
                videoId
              );
            });

          self.statusText = "文件开始上传...";
          console.log(
            "onUploadStarted:" +
              uploadInfo.file.name +
              ", endpoint:" +
              uploadInfo.endpoint +
              ", bucket:" +
              uploadInfo.bucket +
              ", object:" +
              uploadInfo.object
          );
        } else {
          // 如果videoId有值，根据videoId刷新上传凭证
          // https://help.aliyun.com/document_detail/55408.html?spm=a2c4g.11186623.6.630.BoYYcY
          // let refreshUrl =
          //   "https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/RefreshUploadVideo?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&Title=haha1&FileName=xxx.mp4&VideoId=" +
          //   uploadInfo.videoId;
          // axios.get(refreshUrl).then(({ data: any }) => {
          //   let uploadAuth = data.UploadAuth;
          //   let uploadAddress = data.UploadAddress;
          //   let videoId = data.VideoId;
          //   uploader.setUploadAuthAndAddress(
          //     uploadInfo,
          //     uploadAuth,
          //     uploadAddress,
          //     videoId
          //   );
          // });
        }
      },
      // 文件上传成功
      onUploadSucceed: function(uploadInfo: any) {
        console.log(
          "onUploadSucceed: " +
            uploadInfo.file.name +
            ", endpoint:" +
            uploadInfo.endpoint +
            ", bucket:" +
            uploadInfo.bucket +
            ", object:" +
            uploadInfo.object
        );

        self.statusText = "文件上传成功!";
        self.uploading = false;
      },
      // 文件上传失败
      onUploadFailed: function(uploadInfo: any, code: any, message: any) {
        console.log(
          "onUploadFailed: file:" +
            uploadInfo.file.name +
            ",code:" +
            code +
            ", message:" +
            message
        );
        self.statusText = "文件上传失败!";
        self.uploading = false;
      },
      // // 取消文件上传
      // onUploadCanceled: function (uploadInfo, code, message) {
      //   console.log(
      //     "Canceled file: " +
      //       uploadInfo.file.name +
      //       ", code: " +
      //       code +
      //       ", message:" +
      //       message
      //   );
      //   self.statusText = "文件已暂停上传";
      // },
      // // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
      // onUploadProgress: function (uploadInfo, totalSize, progress) {
      //   console.log(
      //     "onUploadProgress:file:" +
      //       uploadInfo.file.name +
      //       ", fileSize:" +
      //       totalSize +
      //       ", percent:" +
      //       Math.ceil(progress * 100) +
      //       "%"
      //   );
      //   let progressPercent = Math.ceil(progress * 100);
      //   self.authProgress = progressPercent;
      //   self.statusText = "文件上传中...";
      // },
      // // 上传凭证超时
      // onUploadTokenExpired: function (uploadInfo) {
      //   // 上传大文件超时, 如果是上传方式一即根据 UploadAuth 上传时
      //   // 需要根据 uploadInfo.videoId 调用刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)重新获取 UploadAuth
      //   // 然后调用 resumeUploadWithAuth 方法, 这里是测试接口, 所以我直接获取了 UploadAuth
      //   let refreshUrl =
      //     "https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/RefreshUploadVideo?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&Title=haha1&FileName=xxx.mp4&VideoId=" +
      //     uploadInfo.videoId;
      //   axios.get(refreshUrl).then(({ data }) => {
      //     let uploadAuth = data.UploadAuth;
      //     uploader.resumeUploadWithAuth(uploadAuth);
      //     console.log(
      //       "upload expired and resume upload with uploadauth " + uploadAuth
      //     );
      //   });
      //   self.statusText = "文件超时...";
      // },
      // 全部文件上传结束
      onUploadEnd: function() {
        console.log("onUploadEnd: uploaded all the files");
        self.statusText = "文件上传完毕";
      }
    });
    console.log(uploader);
    return uploader;
  }

  // uploadSuccess(e: any) {
  //   this.loading = false;
  //   if (e.code === 0) {
  //     this.imageUrl = e.data.url;
  //     this.$message.success("上传成功");
  //   }
  // }
  delImg() {
    // this.$emit("setVideoId", "");
    this.$emit("setVideoUrl", "");
  }
  async downloadVideo() {
    if (!this.imageUrl) {
      this.$message.warning("没有可下载的视频");
      return;
    }

    try {
      // 重置下载进度
      this.downloaded = 0;
      this.downloadTotal = 0;
      this.downloading = true;

      // 使用 fetch 获取视频文件
      const response = await fetch(this.imageUrl);
      if (!response.ok) {
        throw new Error("下载失败");
      }

      // 获取文件总大小
      const contentLength = response.headers.get("content-length");
      this.downloadTotal = contentLength ? parseInt(contentLength, 10) : 0;

      // 如果无法获取文件大小，降级为原来的方式
      if (!this.downloadTotal) {
        const blob = await response.blob();
        this.downloadBlob(blob);
        return;
      }

      // 使用 ReadableStream 读取数据并跟踪进度
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const reader = response.body!.getReader();
      const chunks: any[] = [];

      // eslint-disable-next-line no-constant-condition
      while (true) {
        const { done, value } = await reader.read();

        if (done) {
          break;
        }

        chunks.push(value);
        this.downloaded += value.length;
      }

      // 合并所有数据块
      const blob = new Blob(chunks);
      this.downloadBlob(blob);
    } catch (error) {
      console.error("下载视频失败:", error);
      this.$message.error("下载失败，请稍后重试");
      this.downloading = false;
    }
  }

  downloadBlob(blob: Blob) {
    // 创建 Blob URL
    const blobUrl = window.URL.createObjectURL(blob);

    // 从URL中提取文件名，如果没有则使用默认名称
    const urlParts = this.imageUrl.split("/");
    const fileName = urlParts[urlParts.length - 1] || "video.mp4";

    // 创建临时 a 标签进行下载
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = decodeURIComponent(fileName);
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();

    // 清理
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);

    this.$message.success("下载成功");
    this.downloading = false;
  }
  error() {
    console.log("error");
  }
}
